<div class="app-container">
	<app-login *ngIf="!this.authService.isFullyAuthenticated"></app-login>
	<content-component *ngIf="this.authService.isFullyAuthenticated"></content-component>

	<app-footer></app-footer>
</div>
